module.exports = __webpack_public_path__ + "static/media/material_icon_bullet.e7a5b873.svg";